/* global gsap ScrollTrigger Power2 */

gsap.registerPlugin(ScrollTrigger);
window.horizontalScroll = {};

let __hs = window.horizontalScroll;

__hs.init_images = function (container) {
	container.classList.add('h-scroll');

	let startString = 'top 20%';
	if (container.offsetHeight > (window.innerHeight / 100) * 79) {
		// if the window is < 80% height of the container height, trigger scroll effect when container reaches the window top instead of 20% from the top
		startString = 'top top';
	}

	let sections = gsap.utils.toArray(container.querySelectorAll('li'));
	let hSize = 0;
	sections.forEach(element => {
		hSize += element.offsetWidth;
	});		
	
	let responsiveMargin = __hs.getResponsiveMargin();
	
	hSize = hSize - responsiveMargin - responsiveMargin;
	
	gsap.to(sections, {
		x: 0 - hSize,
		ease: 'none',
		scrollTrigger: {
			trigger: container,
			start: startString,
			pin: true,
			scrub: 0.2,
			// base vertical scrolling on how wide the container is so it feels more natural.
			end: `+=${hSize}`,
			preventOverlaps: true,
			invalidateOnRefresh: true,
			fastScrollEnd: true
			// onLeave: __hs.disableScroll,
			// once: true
		}
	});
};

__hs.disableScroll = function (scrollTrigger) {
	// console.log('__hs.disableScroll', scrollTrigger);
	const scrollWrapper = scrollTrigger.trigger;
	const duration = 0.5;
	const ease = Power2. easeInOut;
	const wrapperHeight = scrollWrapper.offsetHeight;
	
	// console.log('__hs.disableScroll', scrollWrapper);
	gsap.to(scrollWrapper, { transform: 'translate(0px, 0px)', duration: duration, ease: ease });
	gsap.to(scrollWrapper.parentElement, { 'padding-bottom': '0px', height: wrapperHeight, duration: duration, ease: ease });

	// let rewindButtons = scrollWrapper.querySelectorAll('.cir_horizontal_images_scroll_tp');
	// for (let btn of rewindButtons) {
	// 	__hs.fadeInEl(btn);
	// }

	gsap.delayedCall(duration, () => {
		// recalculate all start and end positions of all other ScrollTriggers on the page
		__hs.refreshScrollerMetrics();
	});
};


__hs.refreshScrollerMetrics = function () {
	let scrollers = ScrollTrigger.getAll();
	for (const scroller of scrollers) {
		scroller.refresh();
	}
}


__hs.handleJobCarouselMouseHover = function (event) {
	if (ScrollTrigger.isScrolling() === true) {
		return;
	}
	if (event.type === 'mouseenter') {
		event.target.classList.add('mouseover');
	} else if (event.type === 'mouseleave') {
		event.target.classList.remove('mouseover');
	}
};

__hs.getResponsiveMargin = function () {
	let responsiveMargin = window.innerWidth * 0.35;
	if (window.innerWidth >= 960) {
		responsiveMargin = (window.innerWidth / 100) * 50;
	}

	return responsiveMargin;
}

__hs.init_jobsCarousel = function () {
	let jobsCarousels = document.querySelectorAll('.job-scrolling-container');

	if (jobsCarousels) {
		for (let x = 0; x < jobsCarousels.length; x++) {
			let container = jobsCarousels[x];
			
			if (container === null) {
				continue;
			}

			container.classList.add('h-scroll');

			let responsiveMargin = __hs.getResponsiveMargin();
			responsiveMargin = responsiveMargin * 0.8;		

			let sections = gsap.utils.toArray(container.querySelectorAll('li'));
			let hSize = 0;
			sections.forEach(element => {
				hSize += element.offsetWidth;
			});		
			hSize = hSize - responsiveMargin;

			gsap.to(sections, {
				x: 0 - hSize,
				ease: 'none',
				scrollTrigger: {
					trigger: container,
					start: 'top 4%',
					pin: true,
					scrub: 0.1,
					// base vertical scrolling on how wide the container is so it feels more natural.
					end: `+=${hSize}`,
					preventOverlaps: true,
					invalidateOnRefresh: true
				}
			});

			// handle special cases when scrolling and ScrollTrigger is enabled.
			ScrollTrigger.addEventListener('scrollStart', __hs.scrollingStarted);
			ScrollTrigger.addEventListener('scrollEnd', __hs.scrollingEnded);
			__hs.jobsCarouselItems = document.querySelectorAll('li.job-list-list');
			__hs.jobsCarouselItems.forEach((el) => {
				el.addEventListener('mouseenter', __hs.handleJobCarouselMouseHover);
				el.addEventListener('mouseleave', __hs.handleJobCarouselMouseHover);
			});

			// position the heading so it's centred in the viewport.
			// it's outside the normal containers but isn't being animated so this is a one-off, plus update on resize/orientation-change
			const heading = container.querySelector('.job-listing-heading');
			__hs.horizontallyCentreInViewport(heading);
			// window.addEventListener('resize', function() {__hs.horizontallyCentreInViewport(heading)})
			// window.addEventListener('orientationchange', function() {__hs.horizontallyCentreInViewport(heading)})
		}
	}
};

__hs.horizontallyCentreInViewport = function (element) {
	if (!element) {
		return;
	}
	const elementHalfWidth = element.offsetWidth / 2;
	const elementCurrentCentreX = element.getBoundingClientRect().left + elementHalfWidth;
	const viewportHorizontalCentre = window.innerWidth / 2;
	const xOffset = viewportHorizontalCentre - elementCurrentCentreX;

	gsap.set(element, {x: xOffset});
}

__hs.fadeInEl = function(el) {
	el.classList.remove('inactive');
	gsap.to(el, {autoAlpha: 1, duration: 0.5});
}

__hs.fadeOutEl = function(el) {
	gsap.to(el, {autoAlpha: 0, duration: 0.5, onComplete: function () {el.classList.add('inactive');}});
}

__hs.init_horizontalScrollRewind = function () {
	let rewindButtons = document.querySelectorAll('.cir_horizontal_images_scroll_tp');
	let index = 0;
	for (let btn of rewindButtons) {
		const wrapper = btn.closest('.mainwrapperimages');

		wrapper.id = `mainwrapperimages-${index}`;
		btn.href = `#mainwrapperimages-${index}`;

		btn.addEventListener('click', __hs.rewindScroller);

		index = index + 1;
	}
}

__hs.rewindScroller = function (event) {
	// console.log('__hs.rewindScroller', event);
	const btn = event.currentTarget;
	__hs.fadeOutEl(btn);
	
	
	const wrapper = btn.closest('.mainwrapperimages');
	__hs.init_images(wrapper);
	event.preventDefault();
};

__hs.scrollingStarted = function () {
	// console.log(`scrollingStarted`);
	// if (!__hs || !__hs.jobsCarousel) {
	// 	console.log(`scrollingStarted: bailing`, __hs.jobsCarousel);
	// 	return;
	// }
	// console.log(`scrollingStarted actioning`);

	// __hs.jobsCarousel.classList.add('is-scrolling');
	// __hs.jobsCarousel.classList.remove('not-scrolling');

	let jobsCarousels = document.querySelectorAll('.job-scrolling-container');

	for (const jobsCarousel of jobsCarousels) {
		jobsCarousel.classList.add('is-scrolling');
		jobsCarousel.classList.remove('not-scrolling');
	}

};

__hs.scrollingEnded = function() {
	// if (!__hs || !__hs.jobsCarousel) {
	// 	return;
	// }
	// __hs.jobsCarousel.classList.add('not-scrolling');
	// __hs.jobsCarousel.classList.remove('is-scrolling');

	let jobsCarousels = document.querySelectorAll('.job-scrolling-container');

	for (const jobsCarousel of jobsCarousels) {
		jobsCarousel.classList.add('not-scrolling');
		jobsCarousel.classList.remove('is-scrolling');
	}

	if (!__hs || !__hs.jobsCarouselItems) {
		return;
	}
	__hs.jobsCarouselItems.forEach((el) => {
		el.classList.remove('mouseover');
		if (el.matches(':hover')) {
			el.classList.add('mouseover');
		}
	});
};

__hs.main = function () {

	// It's best that the order of these initialisations is the same as in the DOM,
	// otherwise the start scroll position will be miscalculated
	// We'll make sure it's all ok at the end of this function though.

	document.body.classList.add('scroll-trigger');

	// job carousels
	gsap.matchMedia().add('(min-width: 960px)', __hs.init_jobsCarousel);

	// image blocks
	__hs.hScrollContainers = document.querySelectorAll('.mainwrapperimages');
	for (const container of __hs.hScrollContainers) {
		__hs.init_images(container);
	}

	__hs.init_horizontalScrollRewind();

	// Now all the ScrollTriggers are initialised, make sure they're correctly positioned on the page
	const allScrollers = ScrollTrigger.getAll();
	for (const scroller of allScrollers) {
		scroller.refresh();
	}
	window.onresize = function(event) {
		for (const scroller of allScrollers) {
			scroller.refresh();
		}
	};
};

__hs.main();

